import com.github.chosamuel.AudioContext
import com.github.chosamuel.OscillatorNode
import com.github.chosamuel.kishibe.application.*
import com.github.chosamuel.kishibe.application.renderer.Color
import com.github.chosamuel.kishibe.application.renderer.circle
import com.github.chosamuel.kishibe.application.renderer.clear
import com.github.chosamuel.kishibe.application.renderer.fill
import com.github.chosamuel.kishibe.graphics.createMesh
import com.github.chosamuel.kishibe.math.Vector2
import com.github.chosamuel.kishibe.ui.Radio
import com.github.chosamuel.kishibe.webgl.Shader
import com.github.chosamuel.kishibe.webgl.createShader
import com.github.chosamuel.utils.jsObject
import org.khronos.webgl.WebGLRenderingContext

typealias GL = WebGLRenderingContext

val radio = Radio(4)

var contextStarted = false
val ctx = AudioContext(jsObject {
    latencyHint = "interactive"
    sampleRate = 44100
})
val oscs = mutableListOf<OscillatorNode>()
val gain = ctx.createGain()
val lp = ctx.createBiquadFilter()
var loopCounter = 0

fun main() {
    radio.attach()
    //AUDIO
    repeat(5){
        val osc = ctx.createOscillator()
        osc.type = "sawtooth"
        osc.start()
        oscs.add(osc)
    }
    oscs[0].frequency.value = 36.toFreq()
    oscs[1].frequency.value = 53.toFreq()
    oscs[2].frequency.value = 55.toFreq()
    oscs[3].frequency.value = 58.toFreq()
    gain.gain.value = 0.0

    //filter
    lp.type = "lowpass"
    lp.frequency.value = 270.0
    lp.Q.value = 5.0

    //GRAPH
    oscs.forEach {it.connect(gain)}
    gain.connect(lp)
    lp.connect(ctx.destination)

}
fun updateNotes(){
    when(loopCounter){
        0-> {
            oscs[0].frequency.value = 36.toFreq()
            oscs[1].frequency.value = 53.toFreq()
            oscs[2].frequency.value = 55.toFreq()
            oscs[3].frequency.value = 58.toFreq()
        }
        1->{
            oscs[0].frequency.value = 36.toFreq()
            oscs[1].frequency.value = 51.toFreq()
            oscs[2].frequency.value = 55.toFreq()
            oscs[3].frequency.value = 58.toFreq()
        }
        2->{
            oscs[0].frequency.value = 46.toFreq()
            oscs[1].frequency.value = 51.toFreq()
            oscs[2].frequency.value = 53.toFreq()
            oscs[3].frequency.value = 58.toFreq()
        }
        else->{
            oscs[0].frequency.value = 46.toFreq()
            oscs[1].frequency.value = 50.toFreq()
            oscs[2].frequency.value = 53.toFreq()
            oscs[3].frequency.value = 58.toFreq()
        }
    }
    loopCounter = (loopCounter + 1) % 4
}

var blob: SpringBlob? = null
val res = 90
var shader: Shader? = null
var m = 0.0
var mAccel = 0.0
var mousePrev = Vector2(0.0,0.0)
fun updateSynth(){
    val m = mAccel / 100.0
    val now = ctx.currentTime
    gain.gain.setValueAtTime(m*0.25+0.10,now)
    lp.frequency.setValueAtTime(m*270,now)
}
val app = Application {
    setup {
        canvas.setAttribute("style","touch-action: none")
        console.log("DEFORM II")
        val scale = 0.3
        val radius = if(getWidth() > getHeight()) getHeight() * scale else getWidth() * scale
        blob = SpringBlob(
            Vector2( getWidth()*0.5, getHeight()*0.5),
            radius,
            res
        )
        shader = createShader(vs,fs)
        shader!!.use()
        onClick = {
            if(!contextStarted){
                contextStarted = true
                ctx.resume()
            }
        }
    }
    draw {
        if(frameCount % (60*4) == 0){
            updateNotes()
        }
        if(mouseClicked){
            mAccel += Vector2(mouseX,mouseY)
                .distanceTo(mousePrev)
                .minus(mAccel)
                .times(0.05)
        } else {
            mAccel += (0.0 - mAccel)*0.05
        }
        updateSynth()
        mousePrev = Vector2(mouseX,mouseY)

        shader!!.setUniform1f("time",frameCount.toFloat())
        if(mouseClicked){
            blob!!.center.pos = Vector2(mouseX,mouseY)
        }
        clear(0.0)
        fill(1.0,1.0,1.0)
        val numVertices = blob!!.sp.size + 1
        shader!!.setUniform1f("numVertices",numVertices.toFloat())
        m += (radio.mode - m) * 0.05
        shader!!.setUniform1f("mode", m.toFloat())
        blob?.update(frameCount*1.0)
        val m = createMesh()
        m.addColor(Color(0.0,0.0,0.0))
        m.addVertex(blob!!.center.pos)
        blob!!.sp.forEachIndexed { i, it->
            m.addVertex(it.pos)
            //val value = (i+1.0)/numVertices.toDouble()
            val value = i+1.0;
            m.addColor(Color(value))
        }
        m.addVertex(blob!!.sp[0].pos)
        repeat(numVertices + 1){
            m.addIndex(it.toShort())
        }
        m.draw(WebGLRenderingContext.TRIANGLE_FAN)

    }
}

